import { ActivityType, Activity } from '@/features/course/admin/types/activity';

export const getAreAllActivitiesCompleted = (activities: Activity[]): boolean => {
  return activities
    .filter((activity) => ![ActivityType.Result, ActivityType.Module].includes(activity.type))
    .every((activity) => activity.completed);
};
